module.exports = __webpack_public_path__ + "static/media/custom-ex-17.a9ba62db.jpg";